// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { RepeatableValue } from '@fulcrumapp/fulcrum-core';
import cx from 'classnames';
import ElementView from './base/element-view';
import RepeatableElementTitle from './repeatable-element-title';

export default class RepeatableElementView extends ElementView {
  static propTypes = {
    ...ElementView.propTypes,
    value: PropTypes.instanceOf(RepeatableValue).isRequired,
  };

  renderContent() {
    const { styles } = RepeatableElementView;

    return (
      <div className={styles.container}>
        <RepeatableElementTitle
          value={this.props.value}
          onClick={this.handleClick}
        />
        <div className={css(styles.spacer)} />
      </div>
    );
  }

  handleClick = (event) => {
    this.props.onClick(this.props.value);
  };
}

const styles = cssInJS({
  container: {
    width: '100%',
  },

  spacer: {
    height: 7,
    backgroundColor: '#efefef',
    borderBottom: '1px solid #d9d9d9',
  },
});

RepeatableElementView.styles = styles;
